import React from "react";

const TrophyIcon = ({ width, height, fill }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 23 23" fill="none">
      <path
        d="M5.11111 23V20.4444H10.2222V16.4833C9.17871 16.2491 8.24678 15.807 7.42645 15.157C6.60611 14.507 6.0047 13.6927 5.62222 12.7139C4.025 12.5222 2.68845 11.825 1.61256 10.6222C0.536668 9.41935 -0.000850841 8.00826 1.0109e-06 6.38889V5.11111C1.0109e-06 4.40833 0.250446 3.8065 0.751334 3.30561C1.25222 2.80472 1.85363 2.5547 2.55556 2.55556H5.11111V0H17.8889V2.55556H20.4444C21.1472 2.55556 21.7491 2.806 22.2499 3.30689C22.7508 3.80778 23.0009 4.40919 23 5.11111V6.38889C23 8.00741 22.4621 9.4185 21.3862 10.6222C20.3103 11.8258 18.9741 12.5231 17.3778 12.7139C16.9944 13.6935 16.3926 14.5083 15.5723 15.1583C14.7519 15.8082 13.8204 16.2499 12.7778 16.4833V20.4444H17.8889V23H5.11111ZM5.11111 9.96667V5.11111H2.55556V6.38889C2.55556 7.19815 2.78982 7.92776 3.25833 8.57772C3.72685 9.22769 4.34445 9.69067 5.11111 9.96667ZM17.8889 9.96667C18.6556 9.68982 19.2732 9.22641 19.7417 8.57644C20.2102 7.92648 20.4444 7.1973 20.4444 6.38889V5.11111H17.8889V9.96667Z"
        fill="white"
      />
    </svg>
  );
};

TrophyIcon.defaultProps = {
  width: 23,
  height: 23,
  fill: "white",
};

export default TrophyIcon;
